<script setup lang="ts">
import CuraSoftLogo from "@/components/shared/Logo/CuraSoftLogo.vue";

defineProps<{
  ready: boolean;
  error?: boolean;
}>();

defineEmits<{ retry: [] }>();
</script>

<template>
  <Transition mode="out-in" name="zoom">
    <div
      v-if="error"
      key="auth-error"
      data-test="auth-error"
      class="flex min-h-screen flex-col"
    >
      <div
        class="h-20 shrink-0 bg-cs-900 desktop:border-b desktop:border-gray-700"
      ></div>
      <div class="grid grow place-items-center text-white" role="alert">
        <div class="flex flex-col items-center gap-3 text-center">
          <CuraSoftLogo class="size-12" color="white" />
          <span class="font-display"
            >Benutzer konnte nicht geladen werden.</span
          >
          <button
            class="rounded-sm bg-white px-4 py-2 text-cs-900"
            type="button"
            @click="$emit('retry')"
          >
            Erneut versuchen
          </button>
        </div>
      </div>
    </div>
    <div
      v-else-if="!ready"
      key="auth-loading"
      data-test="auth-loading"
      class="flex min-h-screen flex-col"
    >
      <div
        class="h-20 shrink-0 bg-cs-900 desktop:border-b desktop:border-gray-700"
      ></div>
      <div class="grid grow place-items-center text-white" role="status">
        <div class="flex flex-col items-center gap-3">
          <CuraSoftLogo class="size-12 animate-pulse" color="white" />
          <span class="font-display">Benutzer wird geladen …</span>
        </div>
      </div>
    </div>
    <div v-else key="auth-content" class="contents" data-test="auth-content">
      <slot></slot>
    </div>
  </Transition>
</template>
